

































































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import ReportingService from '../../services/reporting.service';
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';

@Component({
  components: {
    Card,
    VueApexCharts,
  },
})
export default class AdminSystemSummary extends Vue {
  private key: number = 0;
  private summaryData: any = null;
  private deviceTypesHandler: any = new Vue();
  private usersHandler: any = new Vue();
  private devicesHandler: any = new Vue();
  private organisationsHandler: any = new Vue();
  private tabs: any = null;

  private devicesPerWeekOptions: any = {
    chart: {
      id: 'devicesPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private devicesPerWeekSeries: any[] = [{
        name: 'Number of devices',
        data: [],
  }];
  private accDevicesPerWeekOptions: any = {
    chart: {
      id: 'accDevicesPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accDevicesPerWeekSeries: any[] = [{
        name: 'Number of devices',
        data: [],
  }];

  private deviceEnrolmentsPerWeekOptions: any = {
    chart: {
      id: 'deviceEnrolmentsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private deviceEnrolmentsPerWeekSeries: any[] = [{
        name: 'Number of subscribed devices',
        data: [],
  }];
  private accDeviceEnrolmentsPerWeekOptions: any = {
    chart: {
      id: 'accDeviceEnrolmentsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accDeviceEnrolmentsPerWeekSeries: any[] = [{
        name: 'Number of subscribed devices',
        data: [],
  }];

  private deviceDeploymentsRecallsPerWeekOptions: any = {
    chart: {
      id: 'deviceDeploymentsRecallsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private deviceDeploymentsRecallsPerWeekSeries: any[] = [{
        name: 'Number of devices',
        data: [],
  }];

  private accDeviceDeploymentsRecallsPerWeekOptions: any = {
    chart: {
      id: 'accDeviceDeploymentsRecallsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accDeviceDeploymentsRecallsPerWeekSeries: any[] = [{
        name: 'Number of devices',
        data: [],
  }];

  private deviceTypesPerWeekOptions: any = {
    chart: {
      id: 'deviceTypesPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private deviceTypesPerWeekSeries: any[] = [{
        name: 'Number of device types',
        data: [],
  }];
  private accDeviceTypesPerWeekOptions: any = {
    chart: {
      id: 'accDeviceTypesPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accDeviceTypesPerWeekSeries: any[] = [{
        name: 'Number of device types',
        data: [],
  }];
  private organisationsPerWeekOptions: any = {
    chart: {
      id: 'organisationsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private organisationsPerWeekSeries: any[] = [{
        name: 'Number of organisations',
        data: [],
  }];
  private accOrganisationsPerWeekOptions: any = {
    chart: {
      id: 'accOrganisationsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accOrganisationsPerWeekSeries: any[] = [{
        name: 'Number of organisations',
        data: [],
  }];
  private accountsPerWeekOptions: any = {
    chart: {
      id: 'accountsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accountsPerWeekSeries: any[] = [{
        name: 'Number of accounts',
        data: [],
  }];
  private accAccountsPerWeekOptions: any = {
    chart: {
      id: 'accAccountsPerWeek',
    },
    xaxis: {
      categories: [],
    },
  };
  private accAccountsPerWeekSeries: any[] = [{
        name: 'Number of accounts',
        data: [],
  }];

  private async mounted() {
    await this.loadData();
  }

  private async loadData(monthSelect: string = '') {
    this.summaryData = await ReportingService.getSystemSummary(monthSelect);
    this.initDevicesByWeekCharts();
    this.initDevicesSubscribedByWeekCharts();
    this.initDeviceDeploymentsRecallsByWeekCharts();
    this.initDeviceTypesByWeekCharts();
    this.initAccountsByWeekCharts();
    this.initOrganisationsByWeekCharts();
  }

  private async dateChange(e: number) {
    let monthSelect = '';
    switch (Number(e)) {
      case 1:
        monthSelect = 'onemonth';
        break;
      case 2:
        monthSelect = 'twomonths';
        break;
      case 3:
        monthSelect = 'threemonths';
        break;
      case 4:
        monthSelect = 'sixmonths';
        break;
    }
    await this.loadData(monthSelect);
  }

  private initWeekChart(data: any, totalColName: string, chartId: string, seriesSuffix: string, addedPrefix: string = 'New', removePrefix: string = 'Deleted'): any {
    if (data.createdPerWeek && data.createdPerWeek.length) {
      let accumulator = data.totalToDate;
      let accumulator2 = data.totalTerminatedToDate;
      let accumulator3 = accumulator - accumulator2;
      const cats: any[] = [];
      const createdData: any[] = [];
      const terminatedData: any[] = [];
      const deltaData: any[] = [];
      const accCats: any[] = [];
      const accCreatedData: any[] = [];
      const accTerminatedData: any[] = [];
      const accDeltaData: any[] = [];
      for (let i = 0; i < data.createdPerWeek.length; i++) {
        const createdWeek = data.createdPerWeek[i];
        const terminatedWeek = data.terminatedPerWeek[i];

        cats.push(moment.utc(createdWeek.startOfWeek).format('Do MMM YYYY'));
        createdData.push(createdWeek[totalColName]);
        terminatedData.push(terminatedWeek[totalColName]);
        deltaData.push(createdWeek[totalColName] - terminatedWeek[totalColName]);
        const copyCreatedWeek = {
          [totalColName]: Number(createdWeek[totalColName]),
          startOfWeek: createdWeek.startOfWeek,
         };
        const copyTerminatedWeek = {
          [totalColName]: Number(terminatedWeek[totalColName]),
          startOfWeek: terminatedWeek.startOfWeek,
        };

        accumulator = copyCreatedWeek[totalColName] += accumulator;
        accumulator2 = copyTerminatedWeek[totalColName] += accumulator2;
        accumulator3 = accumulator - accumulator2;
        accCats.push(moment.utc(copyCreatedWeek.startOfWeek).format('Do MMM YYYY'));
        accCreatedData.push(copyCreatedWeek[totalColName]);
        accTerminatedData.push(copyTerminatedWeek[totalColName]);
        accDeltaData.push(copyCreatedWeek[totalColName] - copyTerminatedWeek[totalColName]);
      }
      const perWeekOptions = {
        chart: {
          id: chartId,
        },
        xaxis: {
          categories: cats,
        },
        colors: ['#016EA1', '#FF0000', '#00FF00'],
      };
      const perWeekSeries = [
        {
          name: `${addedPrefix} ${seriesSuffix}`,
          data: createdData,
        },
        {
          name: `${removePrefix} ${seriesSuffix}`,
          data: terminatedData,
        },
        {
          name: `Total ${seriesSuffix}`,
          data: deltaData,
        },
      ];
      const accPerWeekOptions = {
        chart: {
          id: `acc${chartId}`,
        },
        xaxis: {
          categories: accCats,
        },
        colors: ['#016EA1', '#FF0000', '#00FF00'],
        fill: {
          colors: ['#016EA1', '#FF0000', '#00FF00'],
          type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
            },
        },
      };
      const accPerWeekSeries = [
        {
          name: `${addedPrefix} ${seriesSuffix}`,
          data: accCreatedData,
        },
        {
          name: `${removePrefix} ${seriesSuffix}`,
          data: accTerminatedData,
        },
        {
          name: `Total ${seriesSuffix}`,
          data: accDeltaData,
        },
      ];

      return { perWeekOptions, perWeekSeries, accPerWeekOptions, accPerWeekSeries };
    }

    return null;
  }

  private initDevicesByWeekCharts() {
    const results = this.initWeekChart({
      createdPerWeek: this.summaryData.devicesCreatedPerWeek,
      terminatedPerWeek: this.summaryData.devicesTerminatedPerWeek,
      totalToDate: this.summaryData.totalDevicesToDate,
      totalTerminatedToDate: this.summaryData.totalTerminatedDevicesToDate,
    }, 'totalDevices', 'devicesPerWeek', 'devices', 'Created', 'Deleted');
    if (results) {
      this.devicesPerWeekOptions = results.perWeekOptions;
      this.devicesPerWeekSeries = results.perWeekSeries;
      this.accDevicesPerWeekOptions = results.accPerWeekOptions;
      this.accDevicesPerWeekSeries = results.accPerWeekSeries;
    }
  }

  private initDevicesSubscribedByWeekCharts() {
    const results = this.initWeekChart({
      createdPerWeek: this.summaryData.devicesEnrolledPerWeek,
      terminatedPerWeek: this.summaryData.devicesTerminatedPerWeek,
      totalToDate: this.summaryData.totalEnrolmentsToDate,
      totalTerminatedToDate: this.summaryData.totalTerminatedDevicesToDate,
    }, 'totalDevices', 'deviceEnrolmentsPerWeek', 'devices', 'Subscribed', 'Deleted');
    if (results) {
      this.deviceEnrolmentsPerWeekOptions = results.perWeekOptions;
      this.deviceEnrolmentsPerWeekSeries = results.perWeekSeries;
      this.accDeviceEnrolmentsPerWeekOptions = results.accPerWeekOptions;
      this.accDeviceEnrolmentsPerWeekSeries = results.accPerWeekSeries;
    }
  }

  private initDeviceDeploymentsRecallsByWeekCharts() {
    const results = this.initWeekChart({
      createdPerWeek: this.summaryData.deviceDeploymentsPerWeek,
      terminatedPerWeek: this.summaryData.deviceRecallsPerWeek,
      totalToDate: this.summaryData.totalDeviceDeploymentsToDate,
      totalTerminatedToDate: this.summaryData.totalDeviceRecallsToDate,
    }, 'totalEvents', 'deviceDeploymentsPerWeek', 'devices', 'Deployed', 'Recalled');
    if (results) {
      this.deviceDeploymentsRecallsPerWeekOptions = results.perWeekOptions;
      this.deviceDeploymentsRecallsPerWeekSeries = results.perWeekSeries;
      this.accDeviceDeploymentsRecallsPerWeekOptions = results.accPerWeekOptions;
      this.accDeviceDeploymentsRecallsPerWeekSeries = results.accPerWeekSeries;
    }
  }

  private initDeviceTypesByWeekCharts() {
    const results = this.initWeekChart({
      createdPerWeek: this.summaryData.deviceTypesCreatedPerWeek,
      terminatedPerWeek: this.summaryData.deviceTypesTerminatedPerWeek,
      totalToDate: this.summaryData.totalDeviceTypesToDate,
      totalTerminatedToDate: this.summaryData.totalTerminatedDeviceTypesToDate,
    }, 'totalDeviceTypes', 'deviceTypesPerWeek', 'device types');
    if (results) {
      this.deviceTypesPerWeekOptions = results.perWeekOptions;
      this.deviceTypesPerWeekSeries = results.perWeekSeries;
      this.accDeviceTypesPerWeekOptions = results.accPerWeekOptions;
      this.accDeviceTypesPerWeekSeries = results.accPerWeekSeries;
    }
  }

  private initOrganisationsByWeekCharts() {
    const results = this.initWeekChart({
      createdPerWeek: this.summaryData.organisationsCreatedPerWeek,
      terminatedPerWeek: this.summaryData.organisationsTerminatedPerWeek,
      totalToDate: this.summaryData.totalOrganisationsToDate,
      totalTerminatedToDate: this.summaryData.totalTerminatedOrganisationsToDate,
    }, 'totalOrganisations', 'organisationsPerWeek', 'organisations');
    if (results) {
      this.organisationsPerWeekOptions = results.perWeekOptions;
      this.organisationsPerWeekSeries = results.perWeekSeries;
      this.accOrganisationsPerWeekOptions = results.accPerWeekOptions;
      this.accOrganisationsPerWeekSeries = results.accPerWeekSeries;
    }
  }

  private initAccountsByWeekCharts() {
    const results = this.initWeekChart({
      createdPerWeek: this.summaryData.accountsCreatedPerWeek,
      terminatedPerWeek: this.summaryData.accountsTerminatedPerWeek,
      totalToDate: this.summaryData.totalAccountsToDate,
      totalTerminatedToDate: this.summaryData.totalTerminatedAccountsToDate,
    }, 'totalAccounts', 'accountsPerWeek', 'accounts');
    if (results) {
      this.accountsPerWeekOptions = results.perWeekOptions;
      this.accountsPerWeekSeries = results.perWeekSeries;
      this.accAccountsPerWeekOptions = results.accPerWeekOptions;
      this.accAccountsPerWeekSeries = results.accPerWeekSeries;
    }
  }

  private initDeviceTypesChart() {
    const options = {
      data: {
        columns: [
          ['All', this.summaryData.deviceVersionCount],
        ],
        type: 'bar',
      },
      axis: {
        x: {
          type: 'category',
          categories: [''],
        },
      },
      bar: {
        width: {
          ratio: 1,
        },
      },
    };
    for (const entry of this.summaryData.networkVersionCount) {
      options.data.columns.push([
        entry.bearer.charAt(0).toUpperCase() + entry.bearer.slice(1),
        entry.total,
      ]);
    }
    this.deviceTypesHandler.$emit('init', options);
  }

  private initUsersChart() {
    const options = {
      data: {
        columns: [
          ['All', this.summaryData.totalUsersCount],
          ['Non Api', this.summaryData.usersCount],
          ['Api', this.summaryData.apiUsersCount],
          ['Daizy', this.summaryData.daizyUsersCount],
          ['External', this.summaryData.nonDaizyUsersCount],
        ],
        type: 'bar',
      },
      axis: {
        x: {
          type: 'category',
          categories: [''],
        },
      },
      bar: {
        width: {
          ratio: 1,
        },
      },
    };
    this.usersHandler.$emit('init', options);
  }

  private initDevicesChart() {
    const options = {
      data: {
        columns: [
          ['All', this.summaryData.totalDevices],
          ['Active', this.summaryData.totalActiveDevices],
          ['Inactive', this.summaryData.totalInactiveDevices],
          ['Fault', this.summaryData.totalFaultDevices],
          ['Lost', this.summaryData.totalLostDevices],
          ['Unknown', this.summaryData.totalUnknownDevices],
        ],
        type: 'bar',
      },
      axis: {
        x: {
          type: 'category',
          categories: [''],
        },
      },
      bar: {
        width: {
          ratio: 1,
        },
      },
    };
    this.devicesHandler.$emit('init', options);
  }
  private initOrganisationChart() {
    const options = {
      data: {
        columns: [
          ['All', this.summaryData.totalOrganisations],
        ],
        type: 'bar',
      },
      axis: {
        x: {
          type: 'category',
          categories: [''],
        },
      },
      bar: {
        width: {
          ratio: 1,
        },
      },
    };
    this.organisationsHandler.$emit('init', options);
  }
}
